import { Fragment, memo, useState, useEffect, useMemo } from 'react'
import './PatientInfoCardRows.scss'
import cl from 'classnames'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { FullTextPositionToolTip } from 'ui_kit_qmd'
import { isActiveEllipsisCheck } from '../../../../../utils/common'
import useMousePosition from '../../../../../utils/hooks/useMousePosition'
import { STATUS_TEXT } from '../../../../../utils/constants'
import { getVisitTypeIconProps } from '../../../../../utils/getVisitTypeIconProps'
import { getVisitTypeLabel } from '../../../../../utils/getVisitTypeLabel'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const getVisitValueId = (visitTypeValue, keyValue) => {
  if (visitTypeValue) {
    return 'patient-info-card-row-visit-type-name'
  }

  if (keyValue === `${STATUS_TEXT}:`) {
    return 'patient-info-card-row-visit-status-name'
  }
}

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
export const PatientInfoCardRows = memo(({ infoConfig }) => {
  const mousePosition = useMousePosition()

  const [isVisitTypeEllipsed, setIsVisitTypeEllipsed] = useState(false)
  const [isMouseOverVisitType, setIsMouseOverVisitType] = useState(false)
  const [visitTypeTooltipTitle, setVisitTypeTooltipTitle] = useState('')
  const [isStatusEllipsed, setIsStatusEllipsed] = useState(false)
  const [isMouseOverStatus, setIsMouseOverStatus] = useState(false)
  const [statusTooltipTitle, setStatusTooltipTitle] = useState('')

  useEffect(() => {
    // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
    isActiveEllipsisCheck(`patient-info-card-row-visit-type-name`, setIsVisitTypeEllipsed)
  }, [isMouseOverVisitType])

  useEffect(() => {
    // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
    isActiveEllipsisCheck('patient-info-card-row-visit-status-name', setIsStatusEllipsed)
  }, [isMouseOverStatus])

  const visitTypeTooltipContainerPositionStyle = useMemo(
    () => ({
      left: mousePosition.Ox,
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      top: mousePosition.Oy + 20,
    }),
    [mousePosition],
  )

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onMouseOverVisitType = (titleValue) => () => {
    if (!visitTypeTooltipTitle) {
      setVisitTypeTooltipTitle(titleValue)
    }
    setIsMouseOverVisitType(true)
  }

  const onMouseOutVisitType = () => setIsMouseOverVisitType(false)

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onMouseOverStatus = (titleValue) => () => {
    if (!statusTooltipTitle) {
      setStatusTooltipTitle(titleValue)
    }
    setIsMouseOverStatus(true)
  }

  const onMouseOutStatus = () => setIsMouseOverStatus(false)

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const getValueMouseOverAction = (visitTypeValue, keyValue, tooltipValue) => {
    if (visitTypeValue) {
      return onMouseOverVisitType(tooltipValue)
    }

    if (keyValue === `${STATUS_TEXT}:`) {
      return onMouseOverStatus(tooltipValue)
    }
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const getValueMouseOutAction = (visitTypeValue, keyValue) => {
    if (visitTypeValue) {
      return onMouseOutVisitType
    }

    if (keyValue === `${STATUS_TEXT}:`) {
      return onMouseOutStatus
    }
  }

  return (
    <>
      {isVisitTypeEllipsed && isMouseOverVisitType ?
        <FullTextPositionToolTip
          title={visitTypeTooltipTitle}
          toolTipContainerPositionStyle={visitTypeTooltipContainerPositionStyle}
        />
      : null}
      {isStatusEllipsed && isMouseOverStatus ?
        <FullTextPositionToolTip
          title={statusTooltipTitle}
          toolTipContainerPositionStyle={visitTypeTooltipContainerPositionStyle}
        />
      : null}
      {/*
       // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered */}
      {infoConfig.map((configItem) => {
        if (Array.isArray(configItem)) {
          return (
            <div className='patient-info-card-row-wrapper'>
              {/*
               // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered */}
              {configItem.map(({ key, visitType, className, value }) => {
                const displayValue = visitType ? getVisitTypeLabel(value, visitType) : value
                const iconProps = visitType ? getVisitTypeIconProps(visitType) : null
                return (
                  <Fragment key={key}>
                    {iconProps ?
                      <img
                        src={iconProps.src}
                        alt={iconProps.alt}
                        style={iconProps.style}
                        className='patient-info-card-row-method-icon'
                      />
                    : null}
                    {key ?
                      <div className='patient-info-card-row-text patient-info-card-row-key'>{key}</div>
                    : null}
                    {value ?
                      <>
                        <div
                          id={getVisitValueId(visitType, key)}
                          className={cl('patient-info-card-row-text patient-info-card-row-value', {
                            'patient-info-card-row-visit-type-name': visitType || key === `${STATUS_TEXT}:`,
                            [className]: className,
                          })}
                          onMouseOver={getValueMouseOverAction(visitType, key, displayValue)}
                          onMouseOut={getValueMouseOutAction(visitType, key)}
                          onFocus={() => {}}
                          onBlur={() => {}}>
                          {displayValue}
                        </div>
                        <div className='patient-info-card-row-separator' />
                      </>
                    : null}
                  </Fragment>
                )
              })}
            </div>
          )
        }

        return (
          <div className='patient-info-card-row-wrapper'>
            <div className='patient-info-card-row-text patient-info-card-row-key'>{configItem.key}</div>
            <div
              id={configItem?.id || null}
              className={`patient-info-card-row-text patient-info-card-row-value${
                configItem?.className ? ` ${configItem?.className}` : ''
              }`}>
              {configItem.value}
            </div>
          </div>
        )
      })}
    </>
  )
})
